import { jwtToken } from './jwt-token';

export const getAccessToken = () => {
  // console.log('jwt', jwtToken);
  if (jwtToken.token) {
    return jwtToken.token;
  }
  return '';
};
